import { useRef, useState } from 'react';
import { useCustomers } from '../lib/customers-api';
import { PopoverPortal } from './PopoverPortal';

export function CustomerPicker({
  value,
  valueName,
  onChange,
  disabled,
}: {
  value: string | null;
  valueName?: string | null;
  onChange: (id: string | null, name: string | null) => void;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [search, setSearch] = useState('');
  const customersQ = useCustomers({
    pageSize: 20,
    ...(search.trim() && { search: search.trim() }),
    active: true,
  });
  const display = valueName || (value ? value.slice(0, 8) : '');
  return (
    <div className="relative">
      <button
        ref={anchorRef}
        type="button"
        className="w-full rounded-md border border-slate-300 px-2 py-1 text-left text-xs"
        onClick={() => !disabled && setOpen((v) => !v)}
        disabled={disabled}
      >
        {display || '— scegli cliente —'}
      </button>
      <PopoverPortal anchorRef={anchorRef} open={open} onClose={() => setOpen(false)}>
        <div className="w-80 rounded-md border border-slate-300 bg-white p-2 shadow-lg">
          <input
            autoFocus
            type="text"
            className="mb-2 block w-full rounded border border-slate-300 px-2 py-1 text-xs"
            placeholder="Cerca cliente..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {value && (
            <button
              type="button"
              onClick={() => {
                onChange(null, null);
                setOpen(false);
                setSearch('');
              }}
              className="mb-2 block w-full rounded border border-slate-200 bg-slate-50 px-2 py-1 text-xs text-slate-600 hover:bg-slate-100"
            >
              ✕ Rimuovi selezione
            </button>
          )}
          <ul className="max-h-56 overflow-y-auto text-xs">
            {customersQ.isLoading && <li className="p-1 text-slate-400">Caricamento...</li>}
            {customersQ.data && customersQ.data.items.length === 0 && (
              <li className="p-1 text-slate-400">Nessun risultato</li>
            )}
            {customersQ.data?.items.map((c) => (
              <li
                key={c.id}
                className="cursor-pointer rounded p-1 hover:bg-slate-100"
                onClick={() => {
                  onChange(c.id, c.name);
                  setOpen(false);
                  setSearch('');
                }}
              >
                <span className="font-mono text-slate-400">{c.code}</span>
                <span className="ml-2 font-medium">{c.name}</span>
                <span className="ml-2 text-slate-500">{c.country}</span>
              </li>
            ))}
          </ul>
        </div>
      </PopoverPortal>
    </div>
  );
}
